import React, { useEffect, useState } from "react";
import { Accordion, AccordionBody, AccordionHeader } from "reactstrap";
import { decryptData } from "../../../utils/helper";
import moment from "moment";
import { calculateAge } from "../../../utils/DateSupport";
import Stepper from "react-stepper-horizontal";
import Loader from "../../../components/Loader/Loader";
import { useNavigate } from "react-router";
import Tooltip from '@mui/material/Tooltip';
import Model from "../../../components/model/Model";
import noProfileImg from "../../../../src/assets/images/noImage.jpg";

function AddApplications({ patientDeatils, getPatient, statusFilter }) {
    const [EnableEditing, setEnableEditing] = useState({ latestUpdate: true, latestCaseNote: true });
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();
    const [notesData, setNotesData] = useState({ latestUpdate: "", latestCaseNote: "" });
    const [openAccordionId, setOpenAccordionId] = useState(null);
    const [openModel, setOpenModel] = useState(false);
    const [childStages, setChildStages] = useState({});
    const userRole = localStorage.getItem("userRole");

    const toggle = (accordionId) => {
        setOpenAccordionId(openAccordionId === accordionId ? null : accordionId);
    };

    useEffect(() => {
        setNotesData({ latestUpdate: "", latestCaseNote: "" });
        setEnableEditing({ latestUpdate: true, latestCaseNote: true });
    }, [statusFilter]);

    const filteredApplications =
    statusFilter === "All"
      ? patientDeatils?.applications
      : statusFilter === "Closed"
      ? patientDeatils?.applications?.filter(
          (app) => app.status === "Approved" || app.status === "NotApproved"
        )
      : patientDeatils?.applications?.filter(
          (app) => app.status === statusFilter
        );

    const handleStepClick = (data, index) => {
        setChildStages({...data,index});
        setOpenModel(true);
    };
    const selectedApplication = patientDeatils?.applications?.find(
        (appln) => appln?._id === openAccordionId
    );

    const activeStepIndex =
        selectedApplication?.stages?.some((stage) => stage.status === "NotApproved")
            ? selectedApplication?.stages.findIndex((stage) => stage.status === "NotApproved")
            : selectedApplication?.stages.every((stage) => stage.status === "Approved")
                ? selectedApplication?.stages.length
                : selectedApplication?.stages.findIndex((stage) => stage.status === "InProcess") !== -1
                    ? selectedApplication?.stages.findIndex((stage) => stage.status === "InProcess")
                    : selectedApplication?.stages.findIndex((stage) => stage.status === "NotStarted") !== -1
                        ? selectedApplication?.stages.findIndex((stage) => stage.status === "NotStarted")
                        : selectedApplication?.stages.length - 1;

    const prevRoute = localStorage.getItem("prevRoute"); // Retrieve stored route
console.log(patientDeatils);

    return (
        <div className='add_applications applications-container m-0 applications-container application_user p-3'>
            {openModel ? (<Model refetch={getPatient} applicationData={childStages} modal={openModel} handleClose={() => setOpenModel(false)} className={"stepper_modal"}/>) : null}
            {isLoading ? <Loader /> : null}
            <div className='collapse_btn'>
                {filteredApplications?.length > 0 ? filteredApplications.map((apln, index) => (
                    <Accordion open={openAccordionId} toggle={toggle} key={apln?._id} className="mb-2">
                        <AccordionHeader targetId={apln?._id}>
                            <div className="d-flex gap-3 align-items-center accordion_blk">
                                <div>
                                    <img src={apln?.patientData?.profile_image?.signedUrl ? apln?.patientData?.profile_image?.signedUrl : noProfileImg} alt="profile" className="collapse_data" />
                                </div>
                                <div className="profile_data">
                                    <h5>{apln?.title}</h5>
                                    <div className="d-flex gap-3 flex-wrap collapse_pro_data">
                                        <p>{calculateAge(moment(decryptData(apln?.patientData?.birthDate)).format("DD-MM-YYYY"))} | {decryptData(apln?.patientData?.gender)} | {decryptData(apln?.patientData?.address?.[0]?.state)} | {apln?.status}</p>
                                    </div>
                                </div>
                            </div>
                            <div className="button_grp">
                                <button className="view_details" onClick={() => navigate("/app/application-detail", {
                                    state: {
                                        applicationData: apln,
                                        isRouteMode: prevRoute === "/clinic/patient-list" ? true : false
                                    }
                                })}
                                >
                                    View Details
                                </button>
                            </div>
                        </AccordionHeader>
                        <AccordionBody accordionId={apln?._id}>
                            <div className="data_patient">
                                <div className="data_tracker">
                                <Stepper
                                    steps={apln?.stages.map((step, index) => {
                                    return {
                                    title: (
                                        <Tooltip title={step.name} arrow>
                                        <div
                                        className="stepper-application"
                                        style={{
                                            cursor: 'pointer',
                                            pointerEvents: 'auto', // Ensure step is clickable
                                            zIndex: 10 // Ensure it is above other elements
                                        }}
                                        onClick={() => handleStepClick({ childStages: step , application:apln },index+1)} // Handle step click
                                        >
                                        <span>{step?.name}</span>
                                        {step?.status === "InProcess" && (
                                            <button
                                            style={{
                                                marginLeft: "10px",
                                                backgroundColor: "#335FFC",
                                                color: "#fff",
                                                border: "none",
                                                borderRadius: "4px",
                                                padding: "4px 6px",
                                                fontWeight:"600",
                                                cursor: "pointer"
                                            }}
                                            >
                                            Current Stage
                                            </button>
                                        )}
                                        {step?.status === "NotApproved" && (
                                            <button
                                            style={{
                                                marginLeft: "10px",
                                                backgroundColor: "#E44545", // Red for rejected
                                                color: "#fff",
                                                border: "none",
                                                borderRadius: "4px",
                                                fontWeight:"600",
                                                padding: "4px 8px",
                                                cursor: "pointer"
                                            }}
                                            >
                                            Not Approved
                                            </button>
                                        )}
                                        </div>
                                        </Tooltip>
                                    ),
                                    onClick: () => {
                                        handleStepClick({ childStages: step, application:apln },index+1);
                                    }};
                                    })}
                                    circleTop={0}
                                    lineMarginOffset={10}
                                    size={50}
                                    activeStep={activeStepIndex}
                                    activeColor={apln.stages[activeStepIndex]?.status === "NotApproved"
                                    ? "#E44545"
                                    : apln.stages[activeStepIndex]?.status === "InProcess"
                                    ? "#ECB800"
                                    : apln.stages[activeStepIndex]?.status === "NotStarted"
                                    ? "#8B8D91"
                                    : "#339900"}
                                    defaultColor={"#8B8D91"}
                                    defaultTitleColor={"#8B8D91"}
                                    completeColor="#339900"
                                    activeTitleColor={apln.stages[activeStepIndex]?.status === "NotApproved"
                                    ? "#E44545"
                                    : apln.stages[activeStepIndex]?.status === "InProcess"
                                    ? "#ECB800"  // Yellow title for in-process
                                    : apln.stages[activeStepIndex]?.status === "NotStarted"
                                    ? "#8B8D91"
                                    : "#339900"}

                                    completeTitleColor="#339900"
                                    activeBarColor={apln.stages[activeStepIndex]?.status === "NotApproved"
                                    ? "#E44545"
                                    : apln.stages[activeStepIndex]?.status === "InProcess"
                                    ? "#ECB800"
                                    : apln.stages[activeStepIndex]?.status === "NotStarted"
                                    ? "#8B8D91"
                                    : "#339900"}
                                    completeBarColor="#339900"
                                />
                                </div>
                                <div className="application_details_block application_patient_blk mt-3">
                                <h3 className="title_name mt-3">Application Overview</h3>
                                <div className="row">
                                    <div className="col-xl-4 col-lg-6 application_details">
                                        <p className="d-flex gap-3">Application Title : <span>{apln?.title}</span></p>
                                    </div>
                                    <div className="col-xl-4 col-lg-6 application_details">
                                        <p className="d-flex gap-3">Consultant : <span>{apln?.consultantUser?.firstName + " " + apln?.consultantUser?.lastName}</span></p>
                                    </div>
                                    <div className="col-xl-4 col-lg-6 application_details">
                                        <p className="d-flex gap-3">Email ID : <span>{apln?.consultantUser?.email}</span></p>
                                    </div>
                                    <div className="col-xl-4 col-lg-6 application_details">
                                        <p className="d-flex gap-3">Application Type : <span>Enrollment</span></p>
                                    </div>
                                    <div className="col-xl-4 col-lg-6 application_details">
                                        <p className="d-flex gap-3">
                                            Active Days :{" "}
                                            <span>
                                                {moment().diff(
                                                    moment(apln?.createdAt),
                                                    "days"
                                                ) +
                                                    " " +
                                                    "Days"}
                                            </span>
                                        </p>
                                    </div>
                                    <div className="col-xl-4 col-lg-6 application_details">
                                        <p className="d-flex gap-3">Latest Update : <span>{apln?.latestUpdate}</span></p>
                                    </div>
                                    {userRole !== "Patient" && (
                                    <div className="col-xl-4 col-lg-6 application_details">
                                        <p className="d-flex gap-3">
                                        Latest Application Notes: <span>{apln?.latestCaseNote}</span>
                                        </p>
                                    </div>
                                    )}
                                    <div className="col-xl-8 application_details">
                                </div>
                                </div>
                                </div>
                        </div>
                    </AccordionBody>
                </Accordion>
            )): <p className="text-center">No Data Found</p>}
        </div>
        </div >
    );
}

export default AddApplications;
